<template>
        <div>
            <v-cookie></v-cookie>
            <div class="place">
                <span>位置：</span>
                <ul class="placeul">
                    <li><a href="#">首页</a></li>
                    <li>云电销</li>
                    <li><a href="#">外呼记录</a></li>
                </ul>
            </div>
            
            <div class="rightinfo">
                <ul class="seachform mt20">
                    <li><label>手机号</label><input name="" v-model="descNum" type="text" class="scinput" /></li>
                    <li>
                        <label>时间:</label>
                        <el-date-picker v-model="startTime"  type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始日期" />
                        <el-date-picker v-model="endTime" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束日期" />
                    </li>
                    <li>
                        <label>状态:</label>
                        <el-select v-model="status" placeholder="请选择">
                            <el-option label="全部" value="-100"></el-option>
                            <el-option label="成功" value="1"></el-option>
                            <el-option label="失败" value="0"></el-option>
                        </el-select>
                    </li>
                    <li><label>&nbsp;</label><input name="" type="button" class="scbtn" @click="pageChange(1)" value="查询"/></li>
                    <li><label>&nbsp;</label><input name="" type="button" class="scbtn" @click="exportDetailBill()" value="导出"/></li>
                </ul>        
            
                <table class="tablelist">
                    <thead>
                        <tr>
                        <th>手机号</th>
                        <th>语音内容</th>
                        <th>状态</th>
                        <th>费用</th>
                        <th>时长</th>
                        <th>开始时间</th>
                        </tr>
                    </thead>
                    <tbody>                
                        <tr v-for="(item,index) in list" :class="{odd:index%2!=0}">
                            <td style="width:10%">{{item.descnum}}</td>
                            <td style="width:45%">{{item.voiceContent}}</td>
                            <td style="width:10%" >{{item.status}}</td>
                            <td style="width:10%">{{item.costfee}}</td>
                            <td style="width:10%">{{item.costtime}}</td>
                            <td style="width:15%">{{item.starttime}}</td>
                        </tr>                 
                    </tbody>
                </table>
            
        
                <div class="pagin">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageIndex"
                        :page-sizes="[50]"
                        :page-size="50"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount">
                    </el-pagination>
                </div>
                
            
                <div class="jian">&nbsp;</div>
                <div class="welinfo">
                    <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                    <b> </b>
                </div>
                
                </div> 
                
                
                <div class="tip">
                    <div class="tiptop"><span>提示信息</span><a></a></div>
                    
                <div class="tipinfo">
                <span><img src="../../assets/images/ticon.png" /></span>
                <div class="tipright">
                <p>是否确认对信息的修改 ？</p>
                <cite>如果是请点击确定按钮 ，否则请点取消。</cite>
                </div>
                </div>
                
                <div class="tipbtn">
                <input name="" type="button"  class="sure" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" value="取消" />
                </div>
            </div>
    
            <!-- 查询等待 -->
            <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                top: 0; left: 0;display: block;" v-show="loadingShow"></div>
            <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
            </div>
    
        </div>
    </template>
    <script>
    import cookie from '@/components/cookie.vue'
    import { openPostWindow,openPostWindow2 } from '../../assets/js/winopen.js';
    export default {
        components : {
            'v-cookie' : cookie,
        },
        data(){
            return{
                descNum:'',
                content:'',
                pageIndex:0,
                totalCount:0,
                list:[],
                loadingShow: true,
                startTime:'',
                endTime:'',
                status:'-100',
            }
        },
        mounted(){
            var data = new Date();
            this.startTime = data.getFullYear() + '-' + (data.getMonth() + 1) + '-' + data.getDate() + " 00:00:00";
            this.endTime = data.getFullYear() + '-' + (data.getMonth() + 1) + '-' + data.getDate() + " 23:59:59";
            this.pageChange(1);
        },
        methods:{
            handleSizeChange(val) {
                this.pageChange(val);
            },
            handleCurrentChange(val) {
                this.pageChange(val);
            },
            pageChange(pageIndex){
                this.loadingShow = true;
                let that = this;
                let data = {'pageIndex':pageIndex,'pageSize':50,'descNum':this.descNum,'voiceContent':this.content, 'status':this.status, 'startTime':this.startTime, 'endTime':this.endTime};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/marketvoice/qrymarketvoicedetailbillpage.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.list = res.data.list;
                        that.pageIndex = parseInt(pageIndex);
                        // that.pageCount = res.data.page.pageCount;
                        that.totalCount = res.data.page.totalCount;
                        that.loadingShow = false;
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            },
            exportDetailBill(){
                this.isDisabled = true;
                var url = this.GLOBAL.serverSrc + '/download/exportmarketdetailbill.json';
                var name = "exportdetailbill";
                let list = [];
                list.push({name: "descNum", value: this.descNum});
                list.push({name: "startTime", value: this.startTime});
                list.push({name: "endTime", value: this.endTime});
                list.push({name: "voiceContent", value: this.content});
                list.push({name: "status", value: this.status});
                list.push({name: "token", value: this.GLOBAL.token});
                openPostWindow(url, list);
            },
        }
    }
    </script>
    


// WEBPACK FOOTER //
// src/components/marketvoice/marketvoicedetailbill.vue